import React from "react";
import Content from "./components/Content";
import Sitemap from "./components/SiteMap";
import Header from "./components/Header";
import Navigation from "./components/Nav";
import AboutSection from "./components/About";
import LanguageSwitcher from "./components/LanguageSwitcher";
import EventItem from "./components/event/EventItem";
import PhotoGallery from "./components/PhotoGallery";
import VideoBgSection from "./components/tenderSection/VideoBgSection";
import MapComponent from "./components/content/MapComponent";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <div className="p-6 bg-white">
      <Toaster position="top-center" reverseOrder={false} />
      <div className="bg-gray-100">
        <Sitemap />
        <Navigation />
        <Header />
        <LanguageSwitcher />
        <main>
          <div id="solutions">
            <Content />
          </div>
          <div id="about">
            <AboutSection />
          </div>
          <div id="news">
            <EventItem />
          </div>
          <div id="gallery">
            <PhotoGallery />
          </div>
          <div id="map">
            <MapComponent />
          </div>
          <div id="tenders">
            <VideoBgSection />
          </div>
          <div id="contact">
            <ContactForm />
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default App;